import { render, staticRenderFns } from "./UploadImg2.vue?vue&type=template&id=26f337a2&"
import script from "./UploadImg2.vue?vue&type=script&lang=js&"
export * from "./UploadImg2.vue?vue&type=script&lang=js&"
import style0 from "./UploadImg2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports